import React from "react";
import Unsubscribe from "../components/User/LoginUser/Unsubscribe.SA";
const UnsubscribeUser: React.FC = () => {
  return (
    <Unsubscribe/>
  );
};

export default UnsubscribeUser;